// extracted by mini-css-extract-plugin
export default {"container":"technology_container__Nl9yH"};